export default (function () {
  return {
    width: [],
    height: [],
    rims: [],
    valueWidth: 225,
    valueHeight: 65,
    valueRim: 17
  };
});